// A labeled band grouping several sections (Setup / Scoring / Publish).
const GroupBand = ({ label, children }) => (
  <div className="space-y-5">
    {label && (
      <h2 className="font-mono text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
        {label}
      </h2>
    )}
    <div className="space-y-6">{children}</div>
  </div>
);

export default GroupBand;
